<template>
  <div class="login">
    <el-form
      class="form"
      ref="formRef"
      :model="formData"
      :rules="rules"
      hide-required-asterisk
    >
      <div class="login_img"></div>
      <div class="flex">
        <div class="content">
          <div class="t1">全链路营销 获客更简单</div>
          <div class="t2">中小企业短视频营销Saas系统</div>
          <div class="t3"><span>账号登陆</span></div>
          <el-form-item label="" prop="username">
            <el-input v-model="formData.username" placeholder="请输入账号">
              <template #prefix>
                <img src="@/assets/img/login_icon1.svg" />
              </template>
            </el-input>
          </el-form-item>
          <el-form-item label="" prop="password">
            <el-input
              v-model="formData.password"
              type="password"
              autocomplete="off"
              show-password
              placeholder="请输入密码"
            >
              <template #prefix>
                <img src="@/assets/img/login_icon2.svg" />
              </template>
            </el-input>
          </el-form-item>
          <el-form-item>
            <el-button
              type="primary"
              style="width: 100%"
              @click="submitForm(formRef)"
              :loading="loading"
            >
              登录
            </el-button>
          </el-form-item>
        </div>
      </div>
    </el-form>
  </div>
</template>

<script setup>
import { ref, reactive, toRefs } from 'vue'
import { useStore } from 'vuex'
import { useRouter, useRoute } from 'vue-router'
import { ElMessage } from 'element-plus'
import { login } from '@/utils/api'
import { is_oem, api } from '@/utils'

const store = useStore()
const { state } = store
const { loading } = toRefs(state)

const router = useRouter()
const route = useRoute()

const oem = is_oem()

const formRef = ref()
const formData = reactive({
  username: process.env.NODE_ENV === 'production' ? '' : 'hzdianqi',
  password: process.env.NODE_ENV === 'production' ? '' : 'abc@66897',
})

const default_rule = {
  message: '请输入',
}
const rules = reactive({
  username: [{ ...default_rule, required: true }],
  password: [{ ...default_rule, required: true }],
})

const submitForm = async (formEl) => {
  if (!formEl) return
  await formEl.validate((valid, fields) => {
    if (valid) {
      login(formData).then(({ data: res }) => {
        ElMessage({
          type: 'success',
          message: res.info,
        })
        if (route.query.redirect) {
          router.replace({ path: route.query.redirect })
        } else {
          router.replace({ name: 'index' })
        }
      })
    } else {
      console.log('error submit!', fields)
    }
  })
}

if (route.query.token) {
  login({
    username: route.query.username,
    token: route.query.token,
  }).then(({ data: res }) => {
    ElMessage({
      type: 'success',
      message: res.info,
    })
    if (route.query.redirect) {
      router.replace({ path: route.query.redirect })
    } else {
      router.replace({ name: 'index' })
    }
  })
}
const location = ref(window.location)
</script>

<style scoped lang="scss">
.login {
  height: 100vh;
  background-color: #fff;
  display: flex;
  justify-content: center;
  align-items: center;
  background: url(@/assets/img/login_bg.png) center / cover;
  color: #000;
  padding: 56px;
  .login_img {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 1076px;
    background: url(@/assets/img/login_img.png) no-repeat center / cover;
  }
  .form {
    min-width: 1100px;
    min-height: 540px;
    background-color: #fff;
    border-radius: 26px;
    display: flex;
    height: 100%;
    overflow: hidden;
    .flex {
      display: flex;
      justify-content: center;
      align-items: center;
      width: 478px;
      min-width: 450px;
    }
    .content {
      width: 390px;
      max-width: 100%;
    }
    .t1 {
      text-align: center;
      margin-bottom: 20px;
      font-size: 36px;
      font-weight: bold;
      margin-left: -20px;
      margin-right: -20px;
    }
    .t2 {
      text-align: center;
      margin-bottom: 65px;
      font-size: 24px;
      color: #4b4b4b;
    }
    .t3 {
      text-align: center;
      margin-bottom: 35px;
      span {
        font-size: 32px;
        font-weight: bold;
        color: #005eff;
        position: relative;
        &::before,
        &::after {
          content: '';
          width: 100px;
          height: 2px;
          background: #005eff;
          opacity: 0.2;
          position: absolute;
          top: 50%;
          margin-top: -1px;
        }
        &::before {
          right: 100%;
          margin-right: 20px;
        }
        &::after {
          left: 100%;
          margin-left: 20px;
        }
      }
    }
    .el-input {
      --el-input-height: 56px;
      --el-input-text-color: #060c14;
      --el-input-border-color: #86a4d3;
      --el-input-focus-border-color: #39a7fb;
      font-size: 16px;
      --el-fill-color-light: #fff;
    }
    .el-button {
      height: 56px !important;
      --el-button-bg-color: #005eff;
      --el-font-size-base: 18px;
      --el-button-font-weight: bold;
      border-radius: 0;
    }
    .el-form-item {
      margin-bottom: 25px;
    }
  }
}
</style>
